import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { useT } from '../i18n';

// Pipeline back button. Defaults to browser-history back; falls back to a route
// when there's no in-app history (deep link / fresh tab) so the user never
// gets bounced off the site. Chevron points right because the layout is RTL.
export default function BackButton({ fallback = '/', label }) {
  const t = useT();
  const navigate = useNavigate();
  const goBack = () => {
    if (window.history.length > 1) navigate(-1);
    else navigate(fallback);
  };
  return (
    <button type="button" className="back-btn" onClick={goBack}>
      <ChevronRight size={18} className="back-btn-icon" aria-hidden="true" />
      {label || t.back}
    </button>
  );
}
